/* import Contact, { ContactProps } from "./Contact";
 */
import Contest, { ContestProps } from "./Contest";
import Gallery, { GalleryProps } from "./Gallery";
import CardPeople, { PeopleProps } from "./People";
import Location, { LocationProps } from "./Location";

import Text, { TextProps } from "./Text";

export type CardProps = {
  _key: string,
  fadeInCursorAction: any,
  fadeOutCursorAction: any,
} & (
  | PeopleProps
  | TextProps
  /*| ContactProps */
  | ContestProps
  | GalleryProps
  | LocationProps
);

const Card: React.FC<CardProps> = (props) => {
  switch (props.variant) {
    case "people":
      return <CardPeople {...props} />;
    case "text":
      return <Text {...props} />;
    /*     case "contact":
      return <Contact {...props} />; */
    case "location":
      return <Location {...props} />;
    case "contest":
      return <Contest {...props} />;
    case "gallery":
      return <Gallery {...props} />;
    default:
      return null;
  }
};

export default Card;
